export default {
  vessel: { name: 'ベッセル', desc: 'このサイトを構築する理由がいくつかあります（lorem ipsum dolor sit amet）。' },
  heatExchanger: { name: '熱交換器', desc: 'このサイトを構築する理由がいくつかあります（lorem ipsum dolor sit amet）。' },
  piping: { name: '配管', desc: 'このサイトを構築する理由がいくつかあります（lorem ipsum dolor sit amet）。' },
  mufle: { name: 'マッフル', desc: 'このサイトを構築する理由がいくつかあります（lorem ipsum dolor sit amet）。' },
  radiantTube: { name: 'ラジアントチューブ', desc: 'このサイトを構築する理由がいくつかあります（lorem ipsum dolor sit amet）。' },
  otherEquipment: { name: 'その他の設備', desc: 'このサイトを構築する理由がいくつかあります（lorem ipsum dolor sit amet）。' },
  fabricationOf: '製作',
  readMore: '続きを読む',
};
